export default function isRequired(values, value) {
  if (value == null || value === undefined || value.trim() === '') {
    return false;
  }

  return true;
}
